import { AlertProps } from '@mui/material';
import { atom, useSetAtom } from 'jotai';

export interface AlertEvent {
  text?: string | string[]
  /**
   * Default to error
   */
  severity?: AlertProps['severity']
  /**
   * Callback to close the error
   * Let undefined to hide the close button
   */
  close?: () => void
}

export type AlertState = AlertEvent[];

export type AlertEventCreation = Omit<AlertEvent, 'id'>;

export const alertsAtom = atom<AlertState>([]);

export const enqueueAlertAtom = atom(null, (get, set, alert: AlertEventCreation) => {
  set(alertsAtom, [...get(alertsAtom), alert]);
});

export const shiftAlertAtom = atom(null, (get, set) => {
  const [, ...rest] = get(alertsAtom);
  set(alertsAtom, rest);
});

export const useAddAlert = () => {
  const setAlerts = useSetAtom(alertsAtom);
  return (alert: AlertEventCreation) => {
    setAlerts((prev) => [...prev, alert]);
  };
};
